export default {
  data () {
    return {
      dialog: null,
      showDialog: false,
      dialogData: null
    }
  },
  beforeMount () {
    let self = this
    this.$root.$on('closeDialog', () => {
      self.showDialog = false
    })
  },
  destroyed () {
    this.$root.$off('closeDialog')
  },
  methods: {
    showIt (dialog, data = null) {
      this.dialog = dialog
      this.showDialog = true
      this.dialogData = data
    },
    centeredPopup (url, winName, w, h, scroll) {
      let leftPosition = (screen.width) ? (screen.width - w) / 2 : 0
      let topPosition = (screen.height) ? (screen.height - h) / 2 : 0
      let settings =
        'height=' + h + ',width=' + w + ',top=' + topPosition + ',left=' + leftPosition + ',scrollbars=' + scroll + ',resizable'
      return window.open(url, winName, settings)
    }
  }
}
